import { ServiceHistoryFilter } from '../models';
import { useGetServiceHistoryQuery } from '../service';

interface UseServiceHistoryProps {
  filters?: ServiceHistoryFilter;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useServiceHistory = ({
  filters,
  paginated
}: UseServiceHistoryProps) => {
  const {
    data: serviceHistory,
    isLoading: isServiceHistoryLoading,
    error,
  } = useGetServiceHistoryQuery({ filters, paginated });

  return {
    serviceHistory: serviceHistory?.items || [],
    totalItems: serviceHistory?.count || [].length,
    totalPages: serviceHistory?.count
      ? Math.ceil(serviceHistory.count / paginated.pageSize)
      : 0,
    isServiceHistoryLoading,
    error,
  };
};

export default useServiceHistory;
